var constants = {
	APP_URL_PREFIX: "",
	API_HOST: "https://confer.literatorapp.com/api/v3/",
	COOKIE_DOMAIN: "literatorapp.com"
};

console.log(process.env.NODE_ENV);

if( process.env.NODE_ENV === "development") {
	constants.API_HOST = "http://riven.zspin.com:8001/api/v3/";
	constants.COOKIE_DOMAIN = "";
}

module.exports = constants;



// WEBPACK FOOTER //
// ./src/components/Constants.js